import { func } from "prop-types";
import { useIdleTimer } from "react-idle-timer";
import { useEffect, useState } from "react";
import { useEditorWebsocket } from "@hooks";
import { useEstimateEditorStore } from "@tools";
import { CircularProgress, Backdrop, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import { DEFAULT_INACTIVE_PERIOD, DEFAULT_INACTIVE_THROTTLE } from "../utils";

export const EstimateEditorInactivityMonitor = ({
  reloadEditorData,
}) => {
  const { t } = useTranslation();
  const socket = useEditorWebsocket();
  const editorStore = useEstimateEditorStore();
  const classes = useStyle();
  
  const [isReloading, setIsReloading] = useState(false);
  
  const onIdle = () => {
    console.log("idle");
    if(document.activeElement)
      document.activeElement.blur();
    socket?.closeEstimate();
    // pause();
  }
  
  const onActive = (data, idleTimer) => {
    if(!idleTimer.isIdle() || isReloading)
      return;
    
    handleAccept();
  }
  
  const { pause, start } = useIdleTimer({
    onIdle,
    onActive,
    timeout: DEFAULT_INACTIVE_PERIOD,
    throttle: DEFAULT_INACTIVE_THROTTLE,
  })
  
  useEffect(() => {
    return () => {
      pause();
    }
  }, []);
  
  const handleAccept = async () => {
    if(isReloading)
      return;
    setIsReloading(true);
    const { hash, estimateData } = await reloadEditorData();
    
    socket?.joinEstimate(estimateData.uuid, hash, editorStore.isCreated, editorStore.currentVersionKey, true);
    setIsReloading(false);
    // showAlert(false);
    start();
  }
  
  // const handleCancel = () => {
  //   if(isReloading)
  //     return;
  //   navigate(home);
  // }
  
  return <Backdrop open={isReloading} className={classes.backdrop}>
    <Grid item container direction="column" justifyContent="center" alignItems="center">
      <CircularProgress color="inherit" />
      <h3 className="mt-3">{t("alerts.editor.idle.wait1")}</h3>
      <h3>{t("alerts.editor.idle.wait2")}</h3>
    </Grid>
  </Backdrop>
  
  // return <Alert
  //   isOpen={visible}
  //   title={t("alerts.editor.idle.title")}
  //   acceptText={(
  //     isReloading
  //     ? <>
  //       <CircularProgress size={ 18 } className="mr-2 text-alt" />
  //       {t("alerts.editor.idle.loading")}
  //     </>
  //     : t("alerts.editor.idle.accept")
  //   )}
  //
  //   cancelText={t("alerts.editor.idle.cancel")}
  //   onAccept={handleAccept}
  //   onCancel={isReloading ? undefined : handleCancel}
  // >
  //   {t("alerts.editor.idle.text")}
  // </Alert>
}

EstimateEditorInactivityMonitor.propTypes = {
  reloadEditorData: func.isRequired
}

const useStyle = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: theme.props.background,
  },
}));